import { RootState } from "../../store";
import { useDispatch, useSelector } from "react-redux";
import { selectStore } from "../../store/selector";
import { Button, Card, Col, DatePicker, Form, Input, message, Modal, Row, Select, Table } from "antd";
import dayjs from "dayjs";
import locale from "antd/es/date-picker/locale/ru_RU";
import { MyBreadcrumb, MyButton, MyModalForm, MyText, OuterTabs } from "../../components";
import { CheckOutlined, CloseOutlined, DeleteOutlined, EditOutlined, EyeOutlined } from "@ant-design/icons";
import React, { useEffect, useMemo, useState } from "react";
import {
  deleteAppear,
  deleteAppearReset,
  deleteMedicalResult,
  deleteMedicalResultReset,
  getFilteredAppear,
  getFilteredGroups,
  getPrintMedical,
  getPrintMedicalGroup, getStudentByGroupID, postAppear, postAppearReset, printCancelEdit,
  printMedicalEdit,
  printMedicalEditReset,
  printSetEdit,
  printStoreReset,
  putAppear,
  putAppearReset
} from "../../store/pages/printJournal/actions";
import { DATE_FORMAT, JOURNAL_TYPES, JOURNAL_TYPES_API, JOURNAL_YEAR, QUERY_PARAMS, ROUTE_PATH } from "../../constants";
import { useTranslation } from "react-i18next";
import { generatePath, useNavigate, useSearchParams } from "react-router-dom";
import { ModalBodyItem, ModalBodyItemText, ModalTitle } from "./index.style";
import TextArea from "antd/es/input/TextArea";
import { STUDENT } from './../../store/constants';
import { Excel } from "antd-table-saveas-excel";
const years = [
  {
    label: `${JOURNAL_YEAR.PREV}-${Number(JOURNAL_YEAR.PREV) + 1}`,
    year: JOURNAL_YEAR.PREV,
  },
  {
    label: `${JOURNAL_YEAR.CURRENT}-${Number(JOURNAL_YEAR.CURRENT) + 1}`,
    year: JOURNAL_YEAR.CURRENT,
  },
  {
    label: `${JOURNAL_YEAR.NEXT}-${Number(JOURNAL_YEAR.NEXT) + 1}`,
    year: JOURNAL_YEAR.NEXT,
  }
]

let sideInitialState = [
  {
    key: 'left',
    value: 'Левая'
  },
  {
    key: 'right',
    value: 'Правая'
  }
]
const FORM_NAME = {
  ID: "id",
  TYPE_NUMBER: 'type_number',
  TYPE_STRING: 'type_string',
  YEAR: 'year',
  COURSE: 'course',
  GROUP: 'group',
  START_DATE: "start_date",
  END_DATE: "end_date",
  STUDENT: "student",
  DATE: "datetime_at",
  REASON: "reason",
  DESCRIPTION: "description",
  RECOMMENDATION: "recommendation"
}

const PRINT_TYPES = {
  MEDICAL: 'medical',
}

let currentFilterInitialState = {
  [FORM_NAME.YEAR]: null,
  [FORM_NAME.COURSE]: null,
  [FORM_NAME.GROUP]: null
}

const rules = [
  {
    required: true,
    message: 'Введите!',
  },
]

export const MedicalRoom = () => {
  const { t } = useTranslation("common")
  const dispatch = useDispatch();
  const [searchParams, setSearchParams] = useSearchParams();
  const typeQuery = searchParams.get(QUERY_PARAMS.type);
  const navigate = useNavigate();
  const {
    printJournal: {
      editAppeals,
      postAppeals,
      studentByGroup,
      appeals,
      modules: modulesState,
      study: studyState,
      medical: medicalState,
      medicalGroups: medicalGroupsState,
      remark: remarkState,
      totalUvr: totalUvrState,
      totalUvrDisciplines: totalUvrDisciplinesState,
      groups: groupsState,
      deleteMedicalResult: delMedicalResultState,
      medicalEdit,
      deleteAppeals
    }
  }: RootState = useSelector(selectStore)

  const [filterForm] = Form.useForm()
  const [filterAppearForm] = Form.useForm()
  const [addAppearForm] = Form.useForm()

  const [type, setType] = useState<string>(typeQuery ? typeQuery : "medical-examination");

  interface IInitDelMedical {
    show: boolean
    id: number | null
    type: string | null
  }
  const initDelMedical: IInitDelMedical = {
    show: false,
    id: null,
    type: null
  }

  const [openModalDeleteMedical, setOpenModalDeleteMedical] = useState<IInitDelMedical>({ ...initDelMedical });

  const [editedObject, setEditedObject] = useState<any>({})
  const [modalAddAppear, setModalAddAppear] = useState<boolean>(false)

  const [currentSide, setCurrentSide] = useState<any>(sideInitialState[0])

  useEffect(() => {
    if (editAppeals.success || postAppeals.success) {
      getAppear(filterAppearForm.getFieldValue(FORM_NAME.YEAR),
        filterAppearForm.getFieldValue(FORM_NAME.GROUP),
        filterAppearForm.getFieldValue(FORM_NAME.START_DATE),
        filterAppearForm.getFieldValue(FORM_NAME.END_DATE)
      )
      dispatch(postAppearReset());
      dispatch(putAppearReset());
      setModalAddAppear(false);
    }
  }, [editAppeals, postAppeals])

  useEffect(() => {
    if (delMedicalResultState?.success || medicalEdit?.success) {
      if (medicalEdit?.success) {
        dispatch(printMedicalEditReset())
      } else if (delMedicalResultState?.success) {
        dispatch(deleteMedicalResultReset())
        setOpenModalDeleteMedical({ ...initDelMedical })
      }

      const values = filterForm.getFieldsValue();
      dispatch(getPrintMedical(values))
      dispatch(getPrintMedicalGroup(values))
    }
  }, [delMedicalResultState, medicalEdit])

  useEffect(() => {
    if (deleteAppeals?.success) {
      sendAppearRequest();
      dispatch(deleteAppearReset())
      setOpenModalDeleteMedical({ ...initDelMedical })
    }
  }, [deleteAppeals])

  const deleteMedical = (id: number | null, type: string | null) => {
    if (type === 'appear') {
      dispatch(deleteAppear(id))
    } else {
      dispatch(deleteMedicalResult(id))
    }
  }
  const getGroups = (year: any, course: any) => {
    if (year && course) {
      dispatch(getFilteredGroups({
        year: year,
        course: course
      }))
    }
  }

  const downloadToExcel = () => {
    const excel = new Excel();
    excel
      .addSheet("Выгрузка")
      .addColumns(columnsToExport)
      .addDataSource(appeals?.data?.appeals)
      .saveAs(`Выгрузка.xlsx`);
  }

  const columnsToExport = [
    {
      title: 'ФИО студента',
      key: 'ФИО студента',
      dataIndex: 'fio',
      width: 200,
      render: (item: any, record: any, index: any) => {
        return record.student
      },
    },
    {
      title: 'Группа',
      key: 'Группа',
      dataIndex: 'group',
      width: 150,
    },
    {
      title: 'Дата',
      key: 'Дата',
      dataIndex: 'datetime_at',
      width: 150,
    },
    {
      title: 'Причина',
      key: 'Причина',
      dataIndex: 'reason',
    },
    {
      title: 'Описание',
      key: 'Описание',
      dataIndex: 'description',
    },
    {
      title: 'Рекомендации',
      key: 'Рекомендации',
      dataIndex: 'recommendation',
    }
  ]

  const getGroupOnEmpty = () => {
    if (!appeals?.data?.groups) {
      getAppear();
    }
  }

  const onCloseModal = () => {
    setModalAddAppear(false)
    addAppearForm.resetFields();
  }

  const getAppear = (year?: any, group?: any, startDate?: any, endDate?: any) => {
    dispatch(getFilteredAppear({
      year: year,
      group: group,
      start_date: startDate && dayjs(startDate).format('YYYY-MM-DD'),
      end_date: endDate && dayjs(endDate).format('YYYY-MM-DD')
    }))
  }

  const addEditAppear = (data: any) => {
    addAppearForm.setFieldsValue({
      ...data,
      [FORM_NAME.DATE]: dayjs(data[FORM_NAME.DATE])
    });
  }

  const sendNewOrEditAppear = (values: any) => {
    const data = {
      ...values,
      datetime_at: dayjs(values?.datetime_at).format(DATE_FORMAT.BACKEND_TIME),
      student_id: values.student
    }
    if (data?.id) {
      dispatch(putAppear(data))
    } else {
      dispatch(postAppear(data))
    }
    addAppearForm.resetFields();
  }

  const handleClickOuterTab = (key: any) => {
    setSearchParams({ type: key })
    setType(key)
    switch (key) {
      case "appeals":
        getAppear();
        break;
      case "medical-examination":
        filterForm.resetFields([FORM_NAME.GROUP])
        getGroups(filterForm.getFieldsValue()[FORM_NAME.YEAR], filterForm.getFieldsValue()[FORM_NAME.COURSE])
        dispatch(printStoreReset())
        setEditedObject({})
        break;
    }
  }
  const getStudentsByGroupFn = (e: any) => {
    addAppearForm.resetFields([FORM_NAME.STUDENT])
    dispatch(getStudentByGroupID({ group_id: e }))
  }


  const handleSaveState = (reduxState: any, index: any, object: any) => {
    let body = {}
    switch (reduxState) {
      case PRINT_TYPES.MEDICAL:
        body = {
          person_id: object.person_id,
          medical_examination_date: editedObject?.object?.date,
          medical_note: editedObject?.object?.note,
          medical_group: editedObject?.object?.group?.name
        }
        dispatch(printMedicalEdit(body))
        // TODO переделать сохранение , сейчас локально пишет , сделать так что бы с бэка приходило 
        // TODO запрос длеать после успешной отработки 
        // пример повторного запроса 
        // const values = filterForm.getFieldsValue();
        // dispatch(getPrintMedical(values))
        // dispatch(getPrintMedicalGroup(values))
        break

      default:
        return false
    }
  }

  const handleEditState = (reduxState: any, index: any, object: any) => {
    let body = { reduxState, index, object }

    setEditedObject((prevState: any) => {
      return {
        reduxState: reduxState,
        object: {
          ...prevState?.object,
          ...object
        }
      }
    })

    if (object.isEdit) {
      dispatch(printSetEdit(body))
    }
  }

  const handleCancelState = (reduxState: any, index: any) => {
    let body = { reduxState, index }
    setEditedObject({})

    dispatch(printCancelEdit(body))
  }

  const onFinishFilter = () => {
    filterForm.validateFields().then((values) => {
      let url = {
        [JOURNAL_TYPES.THEORETICAL]: 'theoretic',
        [JOURNAL_TYPES.INDUSTRIAL]: 'industrial',
      }

      switch (type) {
        case "medical-examination":
          dispatch(getPrintMedical(values))
          dispatch(getPrintMedicalGroup(values))
          break
        default:
          break
      }

    }).catch(() => {
      message.error(t("error"))
    })
  }

  const onValuesChangeFilter = (changedFields: any, allFields: any) => {
    const key = Object.keys(changedFields)[0]
    const value = Object.values(changedFields)[0]
    switch (key) {
      case FORM_NAME.YEAR:
        getGroups(value, filterForm.getFieldsValue()[FORM_NAME.COURSE])
        filterForm.resetFields([FORM_NAME.GROUP])
        break

      case FORM_NAME.COURSE:
        getGroups(filterForm.getFieldsValue()[FORM_NAME.YEAR], value)
        filterForm.resetFields([FORM_NAME.GROUP])
        break

      case FORM_NAME.GROUP:
        break

      default:
        return false
    }
  }

  const sendAppearRequest = () => {
    getAppear(filterAppearForm.getFieldsValue()[FORM_NAME.YEAR],
      filterAppearForm.getFieldsValue()[FORM_NAME.GROUP],
      filterAppearForm.getFieldsValue()[FORM_NAME.START_DATE],
      filterAppearForm.getFieldsValue()[FORM_NAME.END_DATE],
    )
  }

  const goAppearView = (id: string) => {
    const path = {
      pathname: generatePath(ROUTE_PATH.MEDICAL_ROOM_APPEAR_VIEW, { id: id }),
    }
    navigate(path)
  }

  const medicalRender = () => {
    return (
      <Row gutter={[32, 32]}>
        <Col span={24}>
          <MyText size={24} weight={700} color='var(--c-title-text)'>
            Результаты медицинского осмотра обучающихся
          </MyText>
        </Col>

        <Col span={24}>
          <Table columns={medicalColumn} dataSource={medicalState.data} loading={medicalState.loading}
            rowKey={(record) => record.person_id} pagination={false} />
        </Col>
      </Row>
    )
  }
  const appearRender = () => {
    return (
      <Row gutter={[32, 32]}>
        <Col span={24}>
          <Row justify={'space-between'}>
            <MyText size={24} weight={700} color='var(--c-title-text)'>
              Результаты обращений обучающихся
            </MyText>
            <Col>
              {
                appeals?.data?.appeals?.length ? <Button onClick={() => downloadToExcel()}>Выгрузка в Excel</Button> : null
              }
              <Button style={{ marginLeft: 16 }} onClick={() => setModalAddAppear(true)}>Добавить</Button>
            </Col>
          </Row>
        </Col>

        <Col span={24}>
          <Table locale={{
            triggerDesc: t("triggerDesc"),
            triggerAsc: t("triggerAsc"),
            cancelSort: t("cancelSort"),
            emptyText: () =>
              <Row style={{ padding: 32 }} justify={'center'}>
                {
                  appeals?.data?.appeals && filterAppearForm.isFieldsTouched() ? "Ничего не найдено" : "Выберите фильтры для просмотра"
                }
              </Row>
          }} columns={appearColumn} dataSource={appeals?.data?.appeals} loading={appeals.loading}
            rowKey={(appearItem) => appearItem.id} pagination={false} />
        </Col>
      </Row>
    )
  }

  const medicalColumn = [
    {
      title: '№ п/п',
      key: '№ п/п',
      dataIndex: 'index',
      render: (item: any, record: any, index: any) => {
        return index + 1
      },
    },
    {
      title: 'ФИО обучающегося',
      key: 'ФИО обучающегося',
      dataIndex: 'fio',
      render: (item: any, record: any, index: any) => {
        return record.full_name
      },
    },
    {
      title: 'Дата осмотра',
      key: 'Дата осмотра',
      dataIndex: 'date',
      width: 150,
      render: (item: any, record: any, index: any) => {
        return (
          <Row>
            <Col span={24}>
              {record.isEdit ?
                <DatePicker  {...record.medical_data.date ? { defaultValue: dayjs(record.medical_data.date, 'YYYY-MM-DD') } : {}}
                  onChange={(date: any, dateString: any) => handleEditState(PRINT_TYPES.MEDICAL, index, {
                    date: dayjs(date).format('YYYY-MM-DD')
                  })}
                  format='DD.MM.YYYY' showToday={false} locale={locale} /> :
                <MyText>{record.medical_data.date ? dayjs(record.medical_data.date).format('YYYY-MM-DD') : ''}</MyText>}
            </Col>
          </Row>
        )
      },
    },
    {
      title: 'Медгруппа (основная, подготовительная, специальная)',
      key: 'Медгруппа (основная, подготовительная, специальная)',
      dataIndex: 'group',
      width: 150,
      render: (item: any, record: any, index: any) => {
        return (
          <Row>
            <Col span={24}>
              {record.isEdit ?
                <Select
                  style={{ width: '100%' }} {...record.medical_data.group?.name ? { defaultValue: record.medical_data.group?.name } : {}}
                  options={medicalGroupsState.data.map((item: any) => ({
                    key: item.group_type,
                    label: item.caption,
                    value: item.group_type,
                    item: {
                      name: item.group_type,
                      caption: item.caption
                    }
                  }))} onChange={(value, option) => handleEditState(PRINT_TYPES.MEDICAL, index, {
                    // @ts-ignore
                    group: option?.item
                  })} /> :
                <MyText>{record?.medical_data?.group?.caption ? record?.medical_data?.group?.caption : ''}</MyText>}
            </Col>
          </Row>
        )
      },
    },
    {
      title: 'Примечание',
      key: 'Примечание',
      dataIndex: 'note',
      width: 150,
      render: (item: any, record: any, index: any) => {
        return (
          <Row>
            <Col span={24}>
              {record.isEdit ? <Input {...record.medical_data?.note ? { defaultValue: record.medical_data?.note } : {}}
                onChange={(e) => handleEditState(PRINT_TYPES.MEDICAL, index, {
                  note: e.target.value
                })} /> :
                <MyText>{record?.medical_data?.note ? record?.medical_data?.note : ''}</MyText>}
            </Col>
          </Row>
        )
      },
    },
    {
      title: 'Действие',
      key: 'Действие',
      dataIndex: 'action',
      width: 120,
      render: (item: any, record: any, index: any) => {
        return (
          <Row gutter={6} style={{ width: '100%' }} justify='center'>
            <Col>
              {
                record.isEdit ?
                  <MyButton icon={<CheckOutlined />} type='text' width={40} height={40} style={{ padding: 0 }}
                    onClick={() => handleSaveState(PRINT_TYPES.MEDICAL, index, record)} />
                  : <><MyButton icon={<EditOutlined />} type='text' width={40} height={40} style={{ padding: 0 }}
                    onClick={() => handleEditState(PRINT_TYPES.MEDICAL, index, { isEdit: true })} />
                    {
                      record?.medical_data?.id &&
                      <MyButton icon={<DeleteOutlined />} type='text' width={40} height={40} style={{ padding: 0, color: 'red' }}
                        onClick={() => {
                          setOpenModalDeleteMedical({ show: true, id: record?.medical_data?.id, type: 'medical' })
                        }} />
                    }

                  </>
              }
            </Col>
            {
              record.isEdit &&
              <Col>
                <MyButton icon={<CloseOutlined />} type='text' width={40} height={40} style={{ padding: 0 }}
                  onClick={() => handleCancelState(PRINT_TYPES.MEDICAL, index)} />
              </Col>
            }
          </Row>
        )
      },
    }
  ]
  const appearColumn = [
    {
      title: '№ п/п',
      key: '№ п/п',
      dataIndex: 'index',
      width: 60,
      render: (item: any, record: any, index: any) => {
        return index + 1
      },
    },
    {
      title: 'ФИО студента',
      key: 'ФИО студента',
      dataIndex: 'student',
      width: 200,
      sorter: (a: any, b: any) => {
        if (a.student < b.student) {
          return -1;
        }
        if (a.student > b.student) {
          return 1;
        }
        return 0;
      }
    },
    {
      title: 'Группа',
      key: 'Группа',
      dataIndex: 'group',
      width: 150,
      sorter: (a: any, b: any) => {
        if (a.group < b.group) {
          return -1;
        }
        if (a.group > b.group) {
          return 1;
        }
        return 0;
      }
    },
    {
      title: 'Дата',
      key: 'Дата',
      dataIndex: 'datetime_at',
      width: 150,
      sorter: (a: any, b: any) => {
        if (dayjs(a.datetime_at).isBefore(b.datetime_at)) {
          return -1;
        }
        if (dayjs(a.datetime_at).isAfter(b.datetime_at)) {
          return 1;
        }
        return 0;
      }
    },
    {
      title: 'Причина',
      key: 'Причина',
      dataIndex: 'reason',
      ellipsis: true,
    },
    {
      title: 'Описание',
      key: 'Описание',
      dataIndex: 'description',
      ellipsis: true,
    },
    {
      title: 'Рекомендации',
      key: 'Рекомендации',
      dataIndex: 'recommendation',
      ellipsis: true,
    },
    {
      title: 'Действие',
      key: 'Действие',
      dataIndex: 'action',
      width: 140,
      render: (item: any, record: any, index: any) => {
        return (
          <Row gutter={6} style={{ width: '100%' }} justify='center'>
            <Col>
              <MyButton icon={<EyeOutlined />} type='text' width={40} height={40} style={{ padding: 0 }}
                onClick={() => { goAppearView(record.id) }} />
              <MyButton icon={<EditOutlined />} type='text' width={40} height={40} style={{ padding: 0 }}
                onClick={() => {
                  addEditAppear(record)
                  setModalAddAppear(true);
                }} />
              <MyButton icon={<DeleteOutlined />} type='text' width={40} height={40} style={{ padding: 0, color: 'red' }}
                onClick={() => {
                  setOpenModalDeleteMedical({ show: true, id: record?.id, type: 'appear' })
                }} />
            </Col>
          </Row>
        )
      },
    }
  ]

  const filterFormContent = useMemo(() => (
    <Col span={24}>
      <Card>
        <Form form={filterForm}
          layout="vertical"
          onFinish={onFinishFilter}
          onValuesChange={(changedFields, allFields) => onValuesChangeFilter(changedFields, allFields)}
          onReset={() => {
            filterForm.resetFields()
          }}
        >
          <Row align='bottom' gutter={[16, 16]} justify='space-between'>
            <Col span={6}>
              <Form.Item label={t('studyYear')} name={[FORM_NAME.YEAR]} rules={rules}>
                <Select>
                  {
                    years.map(item => (
                      <Select.Option key={item.year} value={item.year}>
                        {item.label}
                      </Select.Option>
                    ))
                  }
                </Select>
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item label={t('course')} name={[FORM_NAME.COURSE]} rules={rules}>
                <Select>
                  {
                    [1, 2, 3, 4].map(item => (
                      <Select.Option key={item} value={item}>
                        {item}
                      </Select.Option>
                    ))
                  }
                </Select>
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item label={t('group')} name={[FORM_NAME.GROUP]} rules={rules}>
                <Select loading={groupsState.loading} showSearch
                  filterOption={(input: any, option: any) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                  {
                    groupsState?.data?.map((item: any) => (
                      <Select.Option key={item.id} value={item.id}>
                        {item.caption}
                      </Select.Option>
                    ))
                  }
                </Select>
              </Form.Item>
            </Col>
            <Col span={3}>
              <Form.Item>
                <MyButton title={t('throw')} htmlType='reset' width='100%' />
              </Form.Item>
            </Col>
            <Col span={3}>
              <Form.Item>
                <MyButton title={t('set')} htmlType='submit' width='100%' />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Card>
    </Col>
  ), [groupsState, type])

  const filterAppearFormContent = useMemo(() => (
    <Col span={24}>
      <Card>
        <Form form={filterAppearForm}
          layout="vertical"
          onFinish={() => sendAppearRequest()}
          onReset={() => {
            getAppear();
            filterAppearForm.resetFields()
          }}
        >
          <Row align='bottom' gutter={[16, 16]} justify='space-between'>
            <Col span={6}>
              <Form.Item label={t('group')} name={[FORM_NAME.GROUP]} >
                <Select placeholder="Выберите группу" onClick={() => getGroupOnEmpty()} loading={appeals?.data?.loading} showSearch filterOption={(input: any, option: any) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                  {
                    appeals?.data?.groups?.map((item: any) => (
                      <Select.Option key={item.id} value={item.id}>
                        {item.group}
                      </Select.Option>
                    ))
                  }
                </Select>
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item label={t('startDate')} name={[FORM_NAME.START_DATE]} >
                <DatePicker locale={locale} placeholder="Выберите дату" format={"DD.MM.YYYY"} style={{ width: "100%" }} />
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item label={t('endDate')} name={[FORM_NAME.END_DATE]} >
                <DatePicker locale={locale} placeholder="Выберите дату" format={"DD.MM.YYYY"} style={{ width: "100%" }} />
              </Form.Item>
            </Col>
            <Col span={3}>
              <Form.Item>
                <MyButton title={t('throw')} htmlType='reset' width='100%' />
              </Form.Item>
            </Col>
            <Col span={3}>
              <Form.Item>
                <MyButton title={t('set')} htmlType='submit' width='100%' />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Card>
    </Col>
  ), [appeals, type])


  const outerItems = [
    {
      key: 'medical-examination',
      label: 'Медосмотр',
      children: (
        <Row>
          {filterFormContent}
          <Col span={24}>
            <Card>
              {medicalRender()}
            </Card>
          </Col>
        </Row>
      ),
    },
    {
      key: 'appeals',
      label: 'Обращения',
      children: (
        <Row>
          {filterAppearFormContent}
          <Col span={24}>
            <Card>
              {appearRender()}
            </Card>
          </Col>
        </Row>
      ),
    },
  ]

  return (
    <>
      {/*<MyBreadcrumb title={t('printJournal')}/>*/}
      <MyBreadcrumb title="Кабинет медицинского работника" />

      <Row justify='center'>
        <Col span={20}>
          <Row>
            <Col span={24}>
              <OuterTabs items={outerItems} onChange={(key) => handleClickOuterTab(key)} activeKey={type} />
            </Col>
          </Row>
        </Col>
      </Row>

      <Modal open={openModalDeleteMedical?.show} onCancel={() => setOpenModalDeleteMedical({ ...initDelMedical })} okText="Удалить" cancelText="Отмена" onOk={() => { deleteMedical(openModalDeleteMedical?.id, openModalDeleteMedical?.type) }}>
        <Row style={{ marginBottom: 12 }}>
          <ModalTitle>Удалить запись №{openModalDeleteMedical?.id}</ModalTitle>
        </Row>
      </Modal>
      <Modal loading={editAppeals.loading || postAppeals.loading} footer={null} onCancel={() => { onCloseModal() }} open={modalAddAppear}>
        <Row style={{ marginBottom: 12 }}>
          <ModalTitle>Добавления обращения</ModalTitle>
        </Row>
        <Form onFinish={(values) => sendNewOrEditAppear(values)}
          onReset={() => { onCloseModal() }}
          form={addAppearForm} layout={"vertical"} >
          <ModalBodyItem style={{ display: 'none' }} name={[FORM_NAME.ID]} >
            <Input></Input>
          </ModalBodyItem>
          <ModalBodyItem label={<ModalBodyItemText>Группа:</ModalBodyItemText>} name={[FORM_NAME.GROUP]} rules={rules}>
            <Select disabled={addAppearForm.getFieldValue(FORM_NAME.ID)} filterOption={(input: any, option: any) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0} onClick={() => getGroupOnEmpty()} onChange={(e) => getStudentsByGroupFn(e)} style={{ width: "100%" }} placeholder='Выберите группу' loading={appeals?.loading} showSearch>
              {
                appeals?.data?.groups?.map((item: any) => (
                  <Select.Option key={item.id} value={item.id}>
                    {item.group}
                  </Select.Option>
                ))
              }
            </Select>
          </ModalBodyItem>
          <ModalBodyItem label={<ModalBodyItemText>ФИО студента:</ModalBodyItemText>} name={[FORM_NAME.STUDENT]} rules={rules}>
            <Select disabled={addAppearForm.getFieldValue(FORM_NAME.ID)} filterOption={(input: any, option: any) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0} style={{ width: "100%" }} placeholder="Выберите студента" loading={studentByGroup?.loading} showSearch>
              {
                studentByGroup?.data?.students?.map((item: any) => (
                  <Select.Option key={item.id} value={item.id}>
                    {item.student}
                  </Select.Option>
                ))
              }
            </Select>
          </ModalBodyItem>
          <ModalBodyItem label={<ModalBodyItemText>Дата и время обращения:</ModalBodyItemText>} name={[FORM_NAME.DATE]} rules={rules}>
            <DatePicker locale={locale} showTime placeholder="Выберите дату" format={DATE_FORMAT.FRONT_TIME} style={{ width: "100%" }} />
          </ModalBodyItem>
          <ModalBodyItem label={<ModalBodyItemText>Причина обращения:</ModalBodyItemText>} name={[FORM_NAME.REASON]} rules={rules}>
            <TextArea rows={4}></TextArea>
          </ModalBodyItem>
          <ModalBodyItem label={<ModalBodyItemText>Описание:</ModalBodyItemText>} name={[FORM_NAME.DESCRIPTION]} rules={rules}>
            <TextArea rows={4}></TextArea>
          </ModalBodyItem>
          <ModalBodyItem label={<ModalBodyItemText>Рекомендации:</ModalBodyItemText>} name={[FORM_NAME.RECOMMENDATION]} rules={rules}>
            <TextArea rows={4}></TextArea>
          </ModalBodyItem>

          <Form.Item >
            <Row justify={'end'}>
              <Button type="default" htmlType="reset">
                Отмена
              </Button>
              <Button style={{ marginLeft: 16 }} type="primary" htmlType="submit">
                {
                  addAppearForm.getFieldValue(FORM_NAME.ID) ? "Сохранить" : "Добавить"
                }
              </Button>
            </Row>
          </Form.Item>
        </Form>

      </Modal>
    </>
  )
}
